import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();
  
  const handleDownload = () => {
    // Direct link to the beta APK
    window.open('https://expo.dev/artifacts/eas/5xguG1EpDELXbKzQw8eseM.apk', '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Hero background image - slight blur and darken */}
      <div className="absolute inset-0">
        <img
          src="/hero.png"
          alt=""
          className="absolute inset-0 w-full h-full object-cover blur-[2px] brightness-90"
          aria-hidden
        />
      </div>

      <div className="container-max text-center text-white relative z-10 py-16 sm:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Main Title */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black leading-[1.1] tracking-tight mb-5 sm:mb-6">
            {t('hero.title')}
          </h1>
          
          {/* Subtitle */}
          <p className="text-lg sm:text-xl md:text-2xl mb-6 sm:mb-8 text-white/95 font-semibold max-w-2xl mx-auto">
            {t('hero.subtitle')}
          </p>
          
          {/* Description */}
          <p className="text-base sm:text-lg mb-10 sm:mb-12 text-white/85 max-w-2xl mx-auto leading-relaxed">
            {t('hero.description')}
          </p>
          
          {/* CTA Button */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={handleDownload}
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-8 py-4 bg-white text-prayer-red font-bold rounded-xl shadow-xl hover:shadow-2xl hover:bg-white/95 transition-all duration-200 text-base sm:text-lg"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              {t('hero.downloadButton')}
            </button>
          </div>
          
          {/* Beta Badge */}
          <div className="mt-8">
            <span className="inline-block bg-white/15 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium border border-white/25">
              {t('hero.betaBadge')}
            </span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <svg className="w-6 h-6 text-white/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>
  );
};

export default Hero; 